import { BasketballAssessment } from 'types/api';
import { GraphTabs } from 'components/GraphTabs';
import styles from './Mechanics.module.css';
import { useConfig } from './useConfig';
import { useRightFootData } from './useRightFootData';

interface RightFootProps {
  assessment: BasketballAssessment;
  className?: string;
}

export const RightFoot = (props: RightFootProps) => {
  const { assessment, className } = props;
  const data = useRightFootData([assessment]);
  const config = useConfig('Right Foot Mechanics', [assessment], data);
  return (
    <GraphTabs
      className={className}
      config={config}
      defaultTab="barTab"
      headerClassName={styles.header}
      heading="Right Foot Mechanics"
    />
  );
};
